import { Injectable } from '@angular/core';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { IconfirmOTP, IEcoupon } from '../model/ecouponInterface';

export interface ILicenseCar {
  car_license: string;
  car_province: string;
}

@Injectable({
  providedIn: 'root',
})
export abstract class ApiService {
  abstract getAllLicensCar(car_license: string, car_province: string): Observable<ILicenseCar>;

  //Post Ecoupon
  abstract postForm(body: IEcoupon): any;
  abstract getDetailCampaign(id: string, brand: string): any;
  abstract getCheckCampaignFull(id: string): any;
  abstract getCheckCampaignExpire(id: string): any;
  //Get Province
  abstract getProvince(): any;
  abstract confirmOTP(body: IconfirmOTP): any;
}
